import toTitleCase from './capitalize'

export const redirectWhatsApp = (name: string, type: keyof typeof MESSAGES = 'default') =>
  window.open(
    `https://api.whatsapp.com/send?phone=5491128677387&text=Hola%2C%20soy%20${toTitleCase(name)}${MESSAGES[type]}`,
    '_blank'
  )

const MESSAGES = {
  pwd: '.%20Quisiera%20cambiar%20%20la%20contraseña%20de%20mi%20billetera%20por%20este%20medio.%20%C2%BFMe%20ayudar%C3%ADas%20a%20completarla%3F',
  default: '%2C%20me%20gustaría%20contactar%20con%20un%20asesor'
}
